__turbopack_context__.v({
  "link": "notification-module-scss-module__iQCt2a__link",
  "message-line-break": "notification-module-scss-module__iQCt2a__message-line-break",
});
